import { parse } from 'querystring'
import React, { FC, useMemo } from 'react'
import { useLocation } from 'react-router'
import * as UI from './BackToThirdPartyBar.styles'

const BackToThirdPartyBar: FC = () => {
  const location = useLocation()

  const parsedSearch = useMemo(() => parse(location.search.replace('?', '')), [location.search])

  const returnUrl = parsedSearch.returnUrl

  if (!returnUrl) {
    return null
  }

  return (
    <UI.Bar href={returnUrl} target="_blank">
      <div className="icon">
        <i className="fa fa-arrow-left"></i>
      </div>
      <span>Return to Event</span>
    </UI.Bar>
  )
}

export { BackToThirdPartyBar }
